// Entrar con el mismo correo y la misma contraseña de Glubi (Decisión 9).
import { useState } from 'react';
import { Button, Input } from '@glubi/ds';
import logotipo from '@glubi/ds/assets/glubi-logotipo.svg';
import { supabase } from '../lib/supabase';

export function Entrar({ aviso }: { aviso?: string }) {
  const [correo, setCorreo] = useState('');
  const [clave, setClave] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [ocupado, setOcupado] = useState(false);

  const entrar = async () => {
    setOcupado(true); setError(null);
    const { error: e } = await supabase.auth.signInWithPassword({ email: correo.trim(), password: clave });
    setOcupado(false);
    if (e) setError(e.code === 'invalid_credentials' ? 'El correo o la contraseña no coinciden.' : 'No se pudo entrar. Revisar los datos e intentar de nuevo.');
  };

  return (
    <div className="entrar">
      <div className="card">
        <img src={logotipo} alt="Glubi" style={{ width: 110, display: 'block', marginBottom: 20 }} />
        <h1 className="h-section">Gateway de IA y MCP</h1>
        <p className="muted" style={{ fontSize: 14, lineHeight: '20px' }}>
          {aviso ?? 'Las conexiones del negocio en un solo lugar: modelos de lenguaje, el POS, los sistemas internos y externos, y sus claves. Con el mismo correo de Glubi.'}
        </p>
        {aviso && <Button variant="secondary" onClick={() => void supabase.auth.signOut()}>Entrar con otra cuenta</Button>}
        {!aviso && (
          <form className="stack" onSubmit={(e) => { e.preventDefault(); void entrar(); }}>
            <Input label="Correo" type="email" value={correo} onChange={(e) => setCorreo(e.target.value)} autoFocus inputMode="email" />
            <Input label="Contraseña" type="password" value={clave} onChange={(e) => setClave(e.target.value)} />
            {error && <div className="error-caja">{error}</div>}
            <Button type="submit" disabled={ocupado || !correo.includes('@') || !clave}>Entrar</Button>
          </form>
        )}
      </div>
    </div>
  );
}
